import React, { useState } from "react";

import { useLocation } from "@reach/router"
import * as queryString from 'query-string';

const PostForm = (props) => {

  const [content, setContent] = useState("");
  const onSubmit = (event) => {
    event.preventDefault();
    //IF SOMETHING BREAKS LOOK AT THIS LINE
    if(content.length > 280) return;
    props.handleSubmit(content, undefined);
    setContent("");
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="flex align-middle h-28 justify-center mb-2">
        <textarea
          className="border-black rounded-md post-form-contentarea w-1/2 text-xl p-2"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          maxLength="280"
          placeholder="Share a memory! (280 characters max)"
        />
        <button
          className="post-form-button cursor-pointer bg-black bg-opacity-75 hover:bg-opacity-40 rounded-md w-28 px-4 py-1 shadow text-white font-bold text-xl text-center"
          disabled={!content.length}
        >
          {props.submitLabel}
        </button>
      </div>
    </form>
  );
};

export default PostForm;
